import Masterlistofmachine from '../../pages/masterlistofMachine/List';
import MasterlistOfCustomer from '../../pages/department/List';
import {
  Clause10,
  ManMachineMatrix,
  ManMachineMatrixList,
} from '../../pages/clause10Page';

// main route of clause 10
export const clause10 = [
  {
    path: 'clause10',
    element: <Clause10 />,
  },
  //Man Machine Matrix
  {
    path: 'manMachineMatrixList',
    element: <ManMachineMatrixList />,
  },
  {
    path: 'manMachineMatrix/:departmentId',
    element: <ManMachineMatrix />,
  },
  {
    path: 'masterlistofmachine',
    element: <Masterlistofmachine />,
  },
  {
    path: 'masterlistofdepartment',
    element: <MasterlistOfCustomer />,
  },
];
